module.exports = __webpack_public_path__ + "static/media/globe_small.f44cd981.svg";